import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/mobile_order_history';

export default function MobileOrderHistory() {
  return (
    <>
      <PageTemplate type={true}>
        <Container />
      </PageTemplate>
    </>
  );
}
